<template>
    <div class="commemt flex align-center" v-if="supplements">
        <div class="input">
            <i></i>
            <input disabled type="text" placeholder="写评论我光荣" />
        </div>
        <div class="btns flex_1 flex align-center justify-bet">
            <div class="item"><span class="cut" v-if="supplements.length > 0">{{ cutString(supplements[0].comment) }}</span></div>
            <div class="item"><span class="cut" v-if="supplements.length > 0">{{ cutString(supplements[0].likes) }}</span></div>
            <div class="item"></div>
            <div class="item"></div>
        </div>
    </div>
</template>

<script>
import { cutString } from "../../util";

export default {
    props: {
        supplements: {
            type: [Array],
            default: {}
        }
    },
    methods: {
        cutString(value) {
            if(value > 99) {
                return '99+'
            } else {
                return value
            }
        }
    }
};
</script>

<style lang="less" scoped>
.commemt {
    position: fixed;
    bottom: 0;
    left: 0;
    height: 3.75rem;
    width: 100%;
    background-color: #fff;
    box-sizing: border-box;
    padding: 0.625rem 1.25rem;
    .input {
        position: relative;
        i {
            position: absolute;
            top: 0.625rem;
            left: 0.75rem;
            width: 1.25rem;
            height: 1.25rem;
            background: url(../assets/img/white.png) no-repeat center center;
            background-size: 100% 100%;
        }
        input {
            width: 8.9375rem;
            height: 2.5rem;
            border: none;
            outline: none;
            background-color: #f8f8f8;
            border-radius: 6px;
            box-sizing: border-box;
            padding-left: 2.25rem;
            font-size: 14px;
            &::placeholder {
                color: #ccc;
            }
        }
    }
    .btns {
        height: 100%;
        padding-left: 1.5rem;
        .item {
            width: 1.5rem;
            height: 1.5rem;
            position: relative;

            span {
                position: absolute;
                top: -0.375rem;
                left: 60%;
                height: 1rem;
                line-height: 0.875rem;
                width: auto;
                padding: 0 5px;
                font-size: 12px;
                font-weight: 400;
                color: rgba(255, 255, 255, 1);
                background-color: #ff4c67;
                border-radius: 8px;
                transform: scale(0.75);
            }
            &:nth-child(1) {
                background: url(../assets/img/line@2x.png) no-repeat center
                    center;
                background-size: 100% 100%;
            }
            &:nth-child(2) {
                background: url(../assets/img/toolbar.png) no-repeat center
                    center;
                background-size: 100% 100%;
            }
            &:nth-child(3) {
                background: url(../assets/img/toolbar@2x.png) no-repeat center
                    center;
                background-size: 100% 100%;
            }
            &:nth-child(4) {
                background: url(../assets/img/share@2x.png) no-repeat center
                    center;
                background-size: 100% 100%;
            }
        }
    }
}
</style>
